module.exports = __webpack_public_path__ + "img/checked.8968483d.svg";